// @flow
import React from 'react';
import { reduxForm } from 'redux-form';
import Fieldset from '@clark-inc/clark-forms';
import { Cta } from 'clark-styles';

import SectionHeader from 'components/shared/section-header';
import Layout from 'components/shared/layout';
import determineCopy from './helpers';
import { FORGOT_FIELD_SET, RESET_FIELD_SET } from './fieldset';

const PasswordForm = ({
  handleSubmit,
  handleClick,
  pristine,
  submitting,
  invalid,
  isForClaimAccount,
  resetPassword,
  controlledLoading,
}) => {
  const isButtonDisabled = invalid || pristine || submitting;
  const { header, subHeader } = determineCopy(isForClaimAccount, resetPassword);
  const FIELDSET = resetPassword ? RESET_FIELD_SET : FORGOT_FIELD_SET;
  return (
    <Layout>
      <SectionHeader headline={header} subHeadline={subHeader} />
      <form onSubmit={handleSubmit(handleClick)}>
        <Fieldset data={FIELDSET} />
        <Cta controlledLoading={controlledLoading} disabled={isButtonDisabled}>
          Submit
        </Cta>
      </form>
    </Layout>
  );
};

export default reduxForm({
  form: 'password',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PasswordForm);



// WEBPACK FOOTER //
// ./src/containers/password-form/index.js